import { render } from "./select-country.vue?vue&type=template&id=3acc09a5"
import script from "./select-country.vue?vue&type=script&lang=js"
export * from "./select-country.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__